"use strict"
exports.__esModule = true;
exports.GooglePlusSquareIconConfig = {
  name: 'GooglePlusSquareIcon',
  height: 512,
  width: 448,
  svgPath: 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z',
  yOffset: 0,
  xOffset: 0,
};
exports.GooglePlusSquareIcon = require('../createIcon').createIcon(exports.GooglePlusSquareIconConfig);
exports["default"] = exports.GooglePlusSquareIcon;